import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: null,
  isUserLoggedIn: false,
  UserName: "",
  EmailId: "",
  RoleName: "",
  RoleCode: "",
};

export const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    setUserLoggedIn: (state, { payload }) => {
      state.token = payload.token;
      state.isUserLoggedIn = true;
      state.UserName = payload.UserName;
      state.EmailId = payload.EmailId;
      state.RoleName = payload.RoleName;
      state.RoleCode = payload.RoleCode;
    },
    setUserLoggedOut: (state) => {
      state.token = null;
      state.isUserLoggedIn = false;
      state.UserName = "";
      state.EmailId = "";
      state.RoleName = "";
      state.RoleCode = "";
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserLoggedIn, setUserLoggedOut } = userSlice.actions;

export default userSlice.reducer;
